  export function encode(input: string): string 
  {
    // Step 1: Convert string to hex
    let hex = '';
    for (let i = 0; i < input.length; i++) {
      hex += input.charCodeAt(i).toString(16).padStart(2, '0');
    }

    // Step 2: Convert hex string to bytes (UTF-8 encoding)
    const encoder = new TextEncoder();
    const hexBytes = encoder.encode(hex);

    // Step 3: Convert bytes to Base64
    let binary = '';
    for (let i = 0; i < hexBytes.length; i++) {
      binary += String.fromCharCode(hexBytes[i]);
    }
    return btoa(binary);
  }

  